export default __webpack_public_path__ + "static/media/step3.a891f93f.webp";